import PropTypes from 'prop-types';
// @mui
import { Box, Card, Link, Typography, Stack, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

// components
import { useAppContext } from '../../../context';

// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

SubscriptionCard.propTypes = {
  subscription: PropTypes.object,
};

export default function SubscriptionCard({ subscription }) {
  const { name, monthlyRate, totalPrice, duration, url, img } = subscription;
  const { user } = useAppContext();
  const navigate = useNavigate();

  const subscriptionState = user?.user?.subscriptionState;

  // Tant qu'un abonnement Stripe vit — y compris impayé — souscrire à nouveau
  // créerait un second abonnement facturé en parallèle : la régularisation
  // passe par le portail, pas par un rachat.
  const canSubscribe = subscriptionState ? subscriptionState.canSubscribe : !user?.user?.subs;

  const buttonLabel = (() => {
    if (canSubscribe) return "S'abonner";
    return subscriptionState?.needsPayment ? 'Paiement à régulariser' : 'Déjà abonné';
  })();

  return (
    <Card>
      <Box sx={{ pt: '100%', position: 'relative' }}>
        <StyledProductImg alt={name} src={img} />
      </Box>

      <Stack spacing={2} sx={{ p: 3 }}>
        <Link color="inherit" underline="hover">
          <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>
        </Link>

        <Stack direction="column" alignItems="flex-start" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">
            Accès en illimité aux cours collectifs pendant la durée de votre abonnement
          </Typography>
          <Typography variant="h4">
            {monthlyRate}€/mois
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Total: {totalPrice}€
          </Typography>
          <Typography variant="caption" minHeight={18}>
            Durée : {duration}
          </Typography>
        </Stack>

        <Button
          variant="contained"
          disabled={!canSubscribe}
          onClick={() => {
            if (user?.user?.id) {
              window.open(`${url}?client_reference_id=${user.user.id}`, '_blank');
            } else {
              navigate('/login', { replace: true });
            }
          }}
        >
          {buttonLabel}
        </Button>
      </Stack>
    </Card>
  );
}
